import React from 'react'
import './Announcement.scss'

function Announcement() {
    return (
        <div id='announcement'>
            <a href="https://buy.stripe.com/cN28x45kt4e22LSdQQ">For a limited time, try capncovers for 3 days free of charge!</a>
        </div>
    )
}

export default Announcement